'use client';

import FormError from '@/components/FormError';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { useWholesaleProgramPage } from '@/hooks/WholesaleProgramPage/useWholesaleProgramPage';
import { Button, Checkbox, Form, Input, Radio } from 'antd';
import { useCallback, useState } from 'react';
import classes from './wholesaleProgramPage.module.css';

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

export const WholesaleForm = () => {
  const talonProps = useWholesaleProgramPage({});

  const { isLoading, handleSubmit, response, formErrors, formApiRef } = talonProps;

  const { isMobile } = useIsMobile();

  const [isOther, setIsOther] = useState(false);

  const onHowKnowChange = useCallback(
    event => {
      if (event.target.value === 'other') {
        setIsOther(true);
      } else {
        setIsOther(false);
      }
    },
    [setIsOther],
  );

  const maybeSuccessInfo =
    response && response.code === '200' ? (
      <p className={classes.successInfo}>
        We have received your application and will get back to you via email within 72 hours!
      </p>
    ) : null;

  const buttonText = isLoading ? 'Sending...' : 'Send';

  return (
    <Form
      ref={formApiRef}
      layout={!isMobile ? 'vertical' : null}
      onFinish={handleSubmit}
      className={classes.form}
      name='nest-messages'
      validateMessages={validateMessages}
    >
      <div className={classes.fieldsContainer}>
        <Form.Item
          name={'firstname'}
          label='First Name'
          className='text-title'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'lastname'}
          label='Last Name'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </div>
      <div className={classes.fieldsContainer}>
        <Form.Item
          name={'email'}
          label='Email'
          normalize={value => (typeof value === 'string' ? value.trim() : value)}
          rules={[
            {
              required: true,
              type: 'email',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'phone'}
          label='Phone Number'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </div>

      <div className={classes.fieldsContainer}>
        <Form.Item
          name={'website'}
          label='Address'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'storelocation'}
          label='Company/Pet Store'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </div>
      <Form.Item
        label='Your Business Type:'
        name='businesstype'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group>
          <Radio value='bm'>Bricks and Mortar</Radio>
          <Radio value='or'>Online Retailer</Radio>
          <Radio value='rd'>Rep Or Distributor</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label='lnterested In:'
        name='interested'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Checkbox.Group>
          <Checkbox value='bf'>Bird Feeders</Checkbox>
          <Checkbox value='bh'>Bird House</Checkbox>
          <Checkbox value='bb'>Bird Baths</Checkbox>
          <Checkbox value='as'>Accessories</Checkbox>
        </Checkbox.Group>
      </Form.Item>
      <Form.Item
        label='How do you know Kingsyard?'
        name='howknow'
        rules={[
          {
            required: true,
          },
        ]}
        onChange={onHowKnowChange}
      >
        <Radio.Group>
          <Radio value='friends'>Friends</Radio>
          <Radio value='instagram'>Instagram</Radio>
          <Radio value='tiktok'>Tiktok</Radio>
          <Radio value='amazon'>Amazon</Radio>
          <Radio value='other'>Others</Radio>
        </Radio.Group>
      </Form.Item>
      {isOther ? (
        <Form.Item
          name={'remark'}
          id='remark'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      ) : null}
      <Form.Item
        name={'story'}
        label='Questions Or Message'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item className={classes.submitButtonForm}>
        <Button
          type='primary'
          disabled={isLoading}
          htmlType='submit'
          className={classes.submitButton}
        >
          {buttonText}
        </Button>
      </Form.Item>
      <FormError errors={formErrors} />
      {maybeSuccessInfo}
    </Form>
  );
};

export default WholesaleForm;
